(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-collection-showcase"] && !Shopify.designMode) return;
  try {
    
/* Muted viewport autoplay; mouse hover temporarily enables sound. Leaving
   always mutes without stopping playback. Touch/keyboard use the sound button.
   Browsers may reject hover audio before a click: resume muted in that case. */
(function () {
  function init(root) {
  root.querySelectorAll('[data-cshow-reel]').forEach(function (tile) {
    if (tile.dataset.sfReelBound) return;
    tile.dataset.sfReelBound = 'true';
    var video = tile.querySelector('video');
    var btn = tile.querySelector('[data-reel-sound]');
    if (!video) return;
    var inView = false;
    var playAttempt = 0;

    // preload="none" defers video bytes, but browsers still fetch posters.
    // Fetch each poster shortly before its tile scrolls into view instead.
    function loadPoster() {
      var poster = video.getAttribute('data-poster');
      if (!poster) return;
      video.poster = poster;
      video.removeAttribute('data-poster');
    }
    if ('IntersectionObserver' in window) {
      var posterObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { loadPoster(); posterObserver.disconnect(); }
        });
      }, { rootMargin: '400px 0px' });
      posterObserver.observe(tile);
    } else {
      loadPoster();
    }

    function syncSound() {
      if (!btn) return;
      var label = video.muted ? 'Turn reel sound on' : 'Turn reel sound off';
      btn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
    }

    function play() {
      if (!inView) return;
      loadPoster();
      var attempt = ++playAttempt;
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function (error) {
        // Ignore superseded requests (pointer left, another click, offscreen).
        if (attempt !== playAttempt || !inView || error.name !== 'NotAllowedError' || video.muted) return;
        video.muted = true;
        syncSound();
        var fallback = video.play();
        if (fallback && fallback.catch) fallback.catch(function () {});
      });
    }

    function setSound(enabled) {
      ++playAttempt;
      video.muted = !enabled;
      syncSound();
      play();
    }

    video.addEventListener('volumechange', syncSound);
    syncSound();
    tile.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'mouse' && inView) setSound(true);
    });
    tile.addEventListener('pointerleave', function (event) {
      if (event.pointerType === 'mouse') setSound(false);
    });

    if (btn) {
      btn.addEventListener('click', function () {
        setSound(video.muted);
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting && e.intersectionRatio >= 0.35;
          if (inView) {
            play();
          } else {
            ++playAttempt;
            video.muted = true;
            syncSound();
            video.pause();
          }
        });
      }, { threshold: 0.35 });
      io.observe(tile);
    } else {
      inView = true;
      play();
    }
  });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-contact"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var h = e.target.closest('[data-sf-acc]');
  if (h && h.closest('.faq-item')) h.closest('.faq-item').classList.toggle('open');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-header"]) return;
  try {
    
(function () {
  var nav = document.getElementById('sf-nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('nav-solid', window.scrollY > 20); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
  var mm = document.getElementById('sf-mm');
  var submenus = document.querySelectorAll('[data-sf-submenu]');
  function closeSubmenus(except) {
    submenus.forEach(function (menu) { if (menu !== except) menu.open = false; });
  }
  submenus.forEach(function (menu) {
    menu.addEventListener('toggle', function () { if (menu.open) closeSubmenus(menu); });
    var group = menu.closest('[data-sf-nav-group]');
    group.addEventListener('focusout', function (e) {
      // Safari can blur the summary without focusing a tapped link. Keep it
      // visible until the click completes; outside clicks still close it below.
      if (e.relatedTarget && !group.contains(e.relatedTarget)) menu.open = false;
    });
  });
  document.addEventListener('click', function (e) {
    submenus.forEach(function (menu) {
      if (!menu.closest('[data-sf-nav-group]').contains(e.target)) menu.open = false;
    });
  });
  window.matchMedia('(max-width:860px)').addEventListener('change', function () { closeSubmenus(); });
  function setMenu(open) {
    if (!mm) return;
    closeSubmenus();
    mm.classList.toggle('open', open);
    mm.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sf-menu-open]')) { e.preventDefault(); setMenu(true); }
    else if (e.target.closest('[data-sf-menu-close]')) { e.preventDefault(); setMenu(false); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var activeSubmenu = Array.from(submenus).find(function (menu) { return menu.open; });
    if (activeSubmenu) {
      activeSubmenu.open = false;
      activeSubmenu.querySelector('summary').focus();
      e.preventDefault();
    } else {
      setMenu(false);
    }
  });

  // currency dropdown
  var curSwitch = document.querySelector('[data-cur-switch]');
  if (curSwitch) {
    // Shopify renders return_to when the page first loads. Filters and variants
    // update the URL without reloading the header, so use the current URL on submit.
    var localizationForm = curSwitch.closest('form');
    localizationForm.addEventListener('submit', function () {
      var returnTo = localizationForm.querySelector('input[name="return_to"]');
      if (!returnTo) {
        returnTo = document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        localizationForm.appendChild(returnTo);
      }
      returnTo.value = window.location.pathname + window.location.search + window.location.hash;
    });
    var curBtn = curSwitch.querySelector('[data-cur-toggle]');
    curBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = curSwitch.classList.toggle('open');
      curBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!curSwitch.contains(e.target)) curSwitch.classList.remove('open');
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-hero-split"] && !Shopify.designMode) return;
  try {
    
/* Split hero — terminal typing loop. One command types out (55ms/char),
   holds, then the next one starts. Skipped under prefers-reduced-motion. */
(function () {
  function init(root) {
  var el = root.querySelector('[data-hsplit-term]');
  if (!el || el.dataset.sfTerminalBound) return;
  el.dataset.sfTerminalBound = 'true';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    el.textContent = 'echo "wear the frenzy"';
    return;
  }
  var cmds = [
    'git commit -m "wear the frenzy"',
    'grep -ri "restock" ./warehouse  # 0 results',
    'chmod +x ship_it.sh && ./ship_it.sh',
    'curl -s shirtsfrenzy.com/drops | head -n 1',
    'echo "when a drop is gone, it is gone"',
    'fortune | cowsay | tee -a drops.log'
  ];
  var i = 0;
  function typeNext() {
    if (!el.isConnected) return;
    var cmd = cmds[i % cmds.length];
    i++;
    var c = 0;
    el.textContent = '';
    var iv = setInterval(function () {
      if (!el.isConnected) { clearInterval(iv); return; }
      c++;
      el.textContent = cmd.slice(0, c);
      if (c >= cmd.length) {
        clearInterval(iv);
        setTimeout(typeNext, 30000);
      }
    }, 55);
  }
  setTimeout(typeNext, 1200);
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

/* Hero card — same model as sf-product-card / sf-cards.js:
   · the track = VIEWS of the current colour; swipe (native scroll-snap + a
     desktop drag helper) carousels through them — no chevrons.
   · a swatch click RECOLOURS IN PLACE: each view's <img> swaps to that colour's
     matching view, the carousel position is kept, nothing slides. */
(function () {
  function init(root) {
  root.querySelectorAll('[data-hero-card]').forEach(function (card) {
    if (card.dataset.sfHeroBound) return;
    card.dataset.sfHeroBound = 'true';
    var track = card.querySelector('[data-hero-track]');
    if (!track) return;
    var imgs = [].slice.call(track.querySelectorAll('.hsplit-imgel'));
    var sws = [].slice.call(card.querySelectorAll('[data-hero-sw]'));
    var dataEl = card.querySelector('[data-hero-imgs]');
    var matrix = {};
    if (dataEl) {
      try {
        JSON.parse(dataEl.textContent).forEach(function (e) {
          if (!e.c) return;
          (matrix[e.c] = matrix[e.c] || []).push(e.u);
        });
      } catch (err) {}
    }
    var stuck = sws[0] && sws[0].getAttribute('data-color');
    function setImg(img, u) {
      if (!u) return;
      if (img.hasAttribute('data-src')) img.setAttribute('data-src', u);
      else { img.srcset = ''; img.src = u; }
    }
    function hydrate() {
      imgs.forEach(function (img) {
        var d = img.getAttribute('data-src');
        if (d) { img.src = d; img.removeAttribute('data-src'); }
      });
    }
    track.addEventListener('pointerenter', hydrate);
    track.addEventListener('touchstart', hydrate, { passive: true });
    track.addEventListener('scroll', hydrate, { passive: true });
    // recolour in place — keeps the current view (carousel position unchanged)
    function paint(color) {
      var list = matrix[color];
      if (!list) return;
      imgs.forEach(function (img, i) { setImg(img, list[i] || list[0]); });
      sws.forEach(function (s) { s.classList.toggle('on', s.getAttribute('data-color') === color); });
    }
    var canHover = window.matchMedia && window.matchMedia('(hover:hover)').matches;
    var swWrap = card.querySelector('[data-hero-swatches]');
    // Strip-level hover (not per-swatch): crossing the 6px gap between circles was
    // firing each swatch's mouseleave → revert to default → flicker. Instead track
    // the swatch NEAREST the cursor across the whole row; only revert when the
    // pointer leaves the row entirely. Mirrors sf-cards.js's style-strip fix.
    if (canHover && swWrap) {
      swWrap.addEventListener('mousemove', function (e) {
        var best = null, bestD = Infinity;
        sws.forEach(function (s) {
          var r = s.getBoundingClientRect();
          var d = Math.abs(e.clientX - (r.left + r.width / 2));
          if (d < bestD) { bestD = d; best = s; }
        });
        if (best) paint(best.getAttribute('data-color'));
      });
      swWrap.addEventListener('mouseleave', function () { paint(stuck); });
    }
    sws.forEach(function (s) {
      var color = s.getAttribute('data-color');
      s.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); stuck = color; paint(color); });
    });
    // desktop drag-to-swipe the VIEWS (touch/trackpad scroll natively); a drag
    // must not fire the slide's PDP link.
    var down = false, moved = false, sx = 0, sl0 = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; sx = e.clientX; sl0 = track.scrollLeft; track.classList.add('dragging');
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      if (Math.abs(e.clientX - sx) > 3) moved = true;
      track.scrollLeft = sl0 - (e.clientX - sx);
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false; track.classList.remove('dragging');
      var i = Math.max(0, Math.round(track.scrollLeft / (track.clientWidth || 1)));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    });
    track.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } });
    });
  });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.currentScript ? document.currentScript.closest('.product') : document;
  var dataEl = document.getElementById('sf-variant-data');
  if (!dataEl) return;
  // Move the original controls (never copies) so DOM/focus order follows the
  // mobile layout. The comment anchors restore the desktop composition on resize.
  var productLayout = document.querySelector('.pdp');
  var mobileMedia = productLayout.querySelector('.pdp-media');
  var mobileInfo = productLayout.querySelector('.pdp-info');
  var mobileForm = document.getElementById('sf-product-form');
  var mobileHeading = mobileInfo.querySelector('.pdp-heading');
  var mobileColors = mobileInfo.querySelector('.pdp-colors');
  var mobileExtras = [mobileInfo.querySelector('.pdp-styleswitch'), mobileInfo.querySelector('.pdp-blurb')].filter(Boolean);
  var movable = [mobileHeading, mobileColors].concat(mobileExtras).filter(Boolean).map(function (el) {
    var anchor = document.createComment('desktop product position');
    el.before(anchor);
    return { el: el, anchor: anchor };
  });
  var responsiveReel = document.getElementById('sf-design-reels');
  var reelEnd = document.querySelector('.pdp-reel-end');
  var mobileQuery = window.matchMedia('(max-width: 920px)');
  function arrangeProduct() {
    var mobile = mobileQuery.matches;
    productLayout.classList.toggle('pdp-mobile-flow', mobile);
    if (responsiveReel && reelEnd) {
      // Reuse the player and its playlist/listeners; never render a second video.
      var reelParent = mobile ? reelEnd : mobileMedia;
      if (responsiveReel.parentElement !== reelParent) reelParent.appendChild(responsiveReel);
      reelEnd.hidden = !mobile;
      mobileMedia.classList.toggle('pdp-media--has-reel', !mobile);
    }
    if (mobile) {
      productLayout.insertBefore(mobileHeading, mobileMedia);
      if (mobileColors) {
        var photo = mobileMedia.querySelector('.pdp-main, .pdp-stack, .pdp-gallery');
        photo.after(mobileColors);
      }
      var afterPurchase = mobileInfo.querySelector('.pdp-assure') || mobileForm;
      mobileExtras.forEach(function (el) { afterPurchase.after(el); afterPurchase = el; });
    } else {
      movable.forEach(function (item) { item.anchor.after(item.el); });
    }
  }
  arrangeProduct();
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', arrangeProduct);
  else mobileQuery.addListener(arrangeProduct);

  var variants = JSON.parse(dataEl.textContent);
  var form = document.getElementById('sf-product-form');
  var idInput = document.getElementById('sf-variant-id');
  var priceEl = document.getElementById('sf-price');
  var addBtn = document.getElementById('sf-add');
  var addLabel = document.getElementById('sf-add-label');
  var mainImg = document.querySelector('#sf-pdp-main .sf-pdp-img');
  var thumbsEl = document.getElementById('sf-pdp-thumbs');
  var mediaEl = document.querySelector('.pdp-media');
  var LAYOUT = mediaEl ? mediaEl.getAttribute('data-layout') : 'default';
  var heroEl = document.getElementById('sf-pdp-main');
  var stackEl = document.getElementById('sf-pdp-stack');
  var galleryEl = document.getElementById('sf-pdp-gallery');
  var IS_HCAR = (LAYOUT === 'carousel' || LAYOUT === 'hero-thumbs');
  var IS_STACK = LAYOUT === 'editorial';
  var IS_GALLERY = LAYOUT === 'gallery-lightbox';
  var curIso = priceEl ? (priceEl.querySelector('.pdp-cur') ? priceEl.querySelector('.pdp-cur').textContent : '') : '';

  // colour -> [view image urls] (from the [c=Colour] alt tags)
  var imgMatrix = {};
  var imgData = document.getElementById('sf-pdp-imgs');
  if (imgData) {
    try { JSON.parse(imgData.textContent).forEach(function (e) { if (!e.c) return; (imgMatrix[e.c] = imgMatrix[e.c] || []).push(e.u); }); } catch (e) {}
  }
  var curView = 0;
  var activeSwInit = document.querySelector('.pdp-sw.on');
  var curColor = activeSwInit ? activeSwInit.getAttribute('data-sf-val') : null;

  // Per-colour size availability — Printful offers the extended sizes
  // (3XL+) only in some colourways, so the rendered size buttons (the
  // union across the product) must grey out per colour. Without this a
  // click on a missing combo matched no variant and silently kept the
  // previous price.
  var sizeBtns = Array.prototype.slice.call(document.querySelectorAll('.pdp-size'));
  var swProbe = document.querySelector('.pdp-sw');
  var colorPos = swProbe ? parseInt(swProbe.getAttribute('data-sf-opt'), 10) : null;
  var sizePos = sizeBtns.length ? parseInt(sizeBtns[0].getAttribute('data-sf-opt'), 10) : null;
  var sizeStatus = document.getElementById('sf-size-status');
  var sizeStorageKey = 'sf-session-size:' + dataEl.getAttribute('data-size-group');
  var requestedSize = (document.querySelector('.pdp-size.on') || {}).textContent;
  requestedSize = requestedSize ? requestedSize.trim() : null;
  var restoredSize = false;
  // Treat the two common spellings as the same size label, not as a fit guarantee.
  function sizeKey(value) {
    value = (value || '').trim().toUpperCase();
    return ({ XXL: '2XL', XXXL: '3XL' })[value] || value;
  }
  function restoreSize() {
    if (!sizePos) return;
    // A deliberately linked variant takes precedence over the browsing preference.
    if (new URLSearchParams(location.search).has('variant')) return;
    try {
      var saved = sessionStorage.getItem(sizeStorageKey);
      if (!saved || saved.length > 32) return;
      var matching = sizeBtns.find(function (b) { return sizeKey(b.getAttribute('data-sf-val')) === sizeKey(saved); });
      requestedSize = matching ? matching.getAttribute('data-sf-val') : saved;
      sizeBtns.forEach(function (b) { b.classList.toggle('on', b === matching); });
      restoredSize = true;
    } catch (e) { /* Storage unavailable: keep the normal product selection. */ }
  }
  function refreshSizeAvail() {
    if (!sizePos || !sizeBtns.length) return;
    var avail = {};
    variants.forEach(function (v) {
      if (!colorPos || !curColor || v.options[colorPos - 1] === curColor) avail[v.options[sizePos - 1]] = true;
    });
    sizeBtns.forEach(function (b) {
      var ok = !!avail[b.getAttribute('data-sf-val')];
      b.classList.toggle('unavail', !ok);
      b.disabled = !ok;
      b.setAttribute('aria-pressed', b.classList.contains('on') ? 'true' : 'false');
    });
    // Keep the requested size selected, even when this colour does not offer it.
    // update() blocks purchase until the shopper chooses a valid combination.
  }
  refreshSizeAvail();

  // ---- in-set Style switcher: hover-preview a sibling on the main media ----
  // Each .pdp-style link carries the sibling's featured image. Hovering swaps
  // the primary visible image; leaving restores it. Click navigates (the <a>).
  var styleEls = Array.prototype.slice.call(document.querySelectorAll('.pdp-style[data-sf-style-img]'));
  // Touch devices synthesize mouseenter on the FIRST tap, which our hover-PREVIEW
  // handlers use to repaint the image — and iOS Safari then swallows that same tap's
  // click, forcing a second tap to actually commit (the swatch/cut double-tap bug).
  // Gate every hover-preview behind a real hover pointer (matches the CSS
  // `@media (hover:none)` convention); the delegated click handlers stay unconditional.
  var CAN_HOVER = !(window.matchMedia && window.matchMedia('(hover: none)').matches);

  if (styleEls.length) {
    // The visible hero image: in the swipe layouts (carousel/hero-thumbs) the
    // hero is a multi-slide track, so target the CURRENT slide (curView), not
    // always the first — otherwise hover only matches when slide 0 is showing.
    var primaryImg = function () {
      if (IS_HCAR && heroEl) {
        var slide = heroEl.children[curView] || heroEl.children[0];
        return slide ? slide.querySelector('.sf-pdp-img') : null;
      }
      return document.querySelector('#sf-pdp-main .sf-pdp-img, #sf-pdp-stack .sf-pdp-img, #sf-pdp-gallery .sf-pdp-img');
    };
    var kindEl = document.querySelector('.pdp-kind');
    var chipNameEl = document.querySelector('.pdp-chip-name');
    var chipIcoEl = document.querySelector('.pdp-chip-ico');
    var labelNameEl = document.querySelector('.pdp-style-label-name');
    var saved = null;
    if (CAN_HOVER) styleEls.forEach(function (el) {
      var url = el.getAttribute('data-sf-style-img');
      var nm = el.getAttribute('data-sf-style-name');
      var pr = el.getAttribute('data-sf-style-price');
      var ico = el.getAttribute('data-sf-style-ico');
      el.addEventListener('mouseenter', function () {
        var img = primaryImg();
        if (saved === null) {
          saved = {
            imgEl: img, src: img ? img.src : null, srcset: img ? (img.srcset || '') : '',
            price: priceEl ? priceEl.innerHTML : null,
            kind: kindEl ? kindEl.textContent : null,
            chip: chipNameEl ? chipNameEl.textContent : null,
            chipIco: chipIcoEl ? chipIcoEl.innerHTML : null,
            label: labelNameEl ? labelNameEl.textContent : null
          };
        }
        if (img && url) { img.srcset = ''; img.src = url; }
        if (priceEl && pr) priceEl.innerHTML = pr + ' <span class="pdp-cur">' + curIso + '</span>';
        if (kindEl && nm) kindEl.textContent = nm;
        if (chipNameEl && nm) chipNameEl.textContent = nm;
        if (chipIcoEl && ico) chipIcoEl.innerHTML = ico;
        if (labelNameEl && nm) labelNameEl.textContent = nm;
      });
      el.addEventListener('mouseleave', function () {
        if (saved === null) return;
        if (saved.imgEl && saved.src !== null) { saved.imgEl.src = saved.src; if (saved.srcset) saved.imgEl.srcset = saved.srcset; }
        if (priceEl && saved.price !== null) priceEl.innerHTML = saved.price;
        if (kindEl && saved.kind !== null) kindEl.textContent = saved.kind;
        if (chipNameEl && saved.chip !== null) chipNameEl.textContent = saved.chip;
        if (chipIcoEl && saved.chipIco !== null) chipIcoEl.innerHTML = saved.chipIco;
        if (labelNameEl && saved.label !== null) labelNameEl.textContent = saved.label;
        saved = null;
      });
    });
  }

  // ---- regional shipping: hide US-only colours for local shoppers + duty note ----
  var SF_REGION = (document.body && document.body.getAttribute('data-sf-region')) || '';
  var xbEl = document.getElementById('sf-xb');
  var xbR = null;
  if (xbEl && SF_REGION) {
    try { var xbAll = JSON.parse(xbEl.textContent); xbR = xbAll && xbAll[SF_REGION]; } catch (e) {}
  }
  function sfPrefAll() { try { return localStorage.getItem('sf-region-pref') === 'all'; } catch (e) { return false; } }
  function xbColorAll(c) { return !!(xbR && xbR[c] === 'all'); }
  function xbCombo(c, sz) {
    if (!xbR || !xbR[c]) return false;
    return xbR[c] === 'all' || (Array.isArray(xbR[c]) && xbR[c].indexOf(sz) !== -1);
  }
  function applyXb() {
    if (!xbR) return;
    var localOnly = !sfPrefAll();
    document.querySelectorAll('.pdp-sw').forEach(function (b) {
      // the active colour stays visible even when US-only (direct links)
      var usOnly = xbColorAll(b.getAttribute('data-sf-val'));
      var hide = localOnly && usOnly && !b.classList.contains('on');
      b.style.display = hide ? 'none' : '';
      // every visible US-only swatch carries a ✈ badge so it can't pass as
      // local — covers the unchecked-toggle stray AND deep links to US colours
      b.classList.toggle('pdp-sw--xb', usOnly && !hide);
      if (usOnly) b.title = b.getAttribute('data-sf-val') + ' — ships from our US studio';
    });
    // active colour name mirrors the badge
    var clOn = document.querySelector('.pdp-sw.on');
    var clEl = document.getElementById('sf-color-label');
    if (clEl && clOn) {
      var clName = clOn.getAttribute('data-sf-val');
      clEl.textContent = xbColorAll(clName) ? clName + ' ✈' : clName;
    }
    var t = document.getElementById('sf-xb-toggle'), ck = document.getElementById('sf-xb-check');
    if (t) t.hidden = false;
    if (ck) ck.checked = !localOnly;
    // "N colours" reflects the visible (regional) palette
    var visSw = Array.prototype.filter.call(document.querySelectorAll('.pdp-sw'), function (b) { return b.style.display !== 'none'; }).length;
    var swWrap = document.querySelector('.pdp-swatches');
    var cnt = swWrap && swWrap.closest('.pdp-opt') ? swWrap.closest('.pdp-opt').querySelector('.pdp-opt-count') : null;
    if (cnt && visSw) cnt.textContent = visSw + (visSw === 1 ? ' colour' : ' colours');
  }
  function dutyNote() {
    var note = document.getElementById('sf-dutynote');
    if (!note) return;
    var c = (document.querySelector('.pdp-sw.on') || {}).getAttribute ? document.querySelector('.pdp-sw.on').getAttribute('data-sf-val') : null;
    var sz = (document.querySelector('.pdp-size.on') || {}).getAttribute ? document.querySelector('.pdp-size.on').getAttribute('data-sf-val') : null;
    note.hidden = !(xbR && c && xbCombo(c, sz));
  }
  var xbCheck = document.getElementById('sf-xb-check');
  if (xbCheck) {
    xbCheck.addEventListener('change', function () {
      try {
        if (xbCheck.checked) localStorage.setItem('sf-region-pref', 'all');
        else localStorage.removeItem('sf-region-pref');
      } catch (e) {}
      applyXb();
    });
  }
  applyXb();
  dutyNote();
  function sizeUrl(u, w) { return u.replace(/([?&])width=\d+/, '$1width=' + w); }
  // hero carousel helpers (carousel layout only)
  function heroSlides(views) {
    return views.map(function (v) { return '<div class="pdp-slide"><img class="sf-pdp-img" src="' + v + '" alt="" loading="lazy"></div>'; }).join('');
  }
  function scrollHeroTo(i) {
    if (heroEl && heroEl.children[i]) heroEl.scrollTo({ left: heroEl.children[i].offsetLeft, behavior: 'smooth' });
  }
  function setActiveThumb(i) {
    if (!thumbsEl) return;
    var ts = thumbsEl.querySelectorAll('.pdp-thumb');
    ts.forEach(function (t, k) { t.classList.toggle('on', k === i); });
    if (ts[i]) ts[i].scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
  }
  function paintColor(color) {
    var views = imgMatrix[color];
    if (!views || !views.length) return;
    curColor = color;
    if (curView >= views.length) curView = 0;
    if (IS_STACK && stackEl) {
      stackEl.innerHTML = views.map(function (v) { return '<div class="pimg pdp-stack-img"><img class="sf-pdp-img" src="' + v + '" loading="lazy" alt=""></div>'; }).join('');
      return;
    }
    if (IS_GALLERY && galleryEl) {
      galleryEl.innerHTML = views.map(function (v, i) { return '<button type="button" class="pimg pdp-gallery-img" data-sf-lb="' + i + '"><img class="sf-pdp-img" src="' + v + '" loading="lazy" alt=""></button>'; }).join('');
      return;
    }
    if (IS_HCAR && heroEl) {
      heroEl.innerHTML = heroSlides(views);
      heroEl.scrollLeft = heroEl.children[curView] ? heroEl.children[curView].offsetLeft : 0;
    } else if (mainImg) { mainImg.srcset = ''; mainImg.src = views[curView]; }
    if (thumbsEl) {
      var list = (LAYOUT === 'carousel' || LAYOUT === 'hero-thumbs') ? views : views.slice(0, 6);
      thumbsEl.innerHTML = list.map(function (v, i) {
        return '<button class="pdp-thumb' + (i === curView ? ' on' : '') + '" data-sf-thumb="' + v + '" aria-label="View ' + (i + 1) + '">'
          + '<div class="pimg"><img src="' + sizeUrl(v, 200) + '" loading="lazy" alt=""></div></button>';
      }).join('');
    }
  }

  function selected() {
    var opts = {};
    document.querySelectorAll('[data-sf-opt]').forEach(function (el) {
      if (el.tagName === 'SELECT') { opts[el.getAttribute('data-sf-opt')] = el.value; }
      else if (el.classList.contains('on')) { opts[el.getAttribute('data-sf-opt')] = el.getAttribute('data-sf-val'); }
    });
    // A saved size absent from this garment must not fall back to its default.
    if (sizePos && requestedSize) opts[String(sizePos)] = requestedSize;
    return opts;
  }
  function money(cents) {
    return (curIso ? '' : '$') + '$'.replace('$', '') + (cents / 100).toFixed(2);
  }
  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  function match() {
    var sel = selected();
    return variants.find(function (v) {
      return v.options.every(function (val, i) { return sel[String(i + 1)] === val; });
    });
  }
  function update() {
    var v = match();
    var valid = !!(v && v.available);
    if (idInput) { idInput.value = valid ? v.id : ''; idInput.disabled = !valid; }
    if (window.history && window.history.replaceState) {
      var u = new URL(window.location.href);
      if (v) u.searchParams.set('variant', v.id);
      else u.searchParams.delete('variant');
      window.history.replaceState({}, '', u.href);
    }
    if (priceEl) priceEl.innerHTML = v ? (fmt(v.price) + ' <span class="pdp-cur">' + curIso + '</span>') : 'Combination unavailable';
    if (addBtn) addBtn.disabled = !valid;
    if (addLabel) addLabel.textContent = valid ? ('Add to cart — ' + fmt(v.price)) : (v ? 'Sold out' : 'Choose an available size or colour');
    if (sizeStatus) {
      var requested = sizePos && selected()[String(sizePos)];
      var offered = sizeBtns.some(function (b) { return b.getAttribute('data-sf-val') === requested; });
      sizeStatus.textContent = !v && requested
        ? (offered
          ? requested + ' is not available in ' + curColor + '. Choose another colour to keep this size, or select an available size.'
          : 'Your saved size ' + requested + ' is not offered in this style. Choose an available size or try another style.')
        : (v && !v.available ? 'This combination is sold out. Choose another size or colour.'
          : (restoredSize ? 'Your saved size: ' + requested + '. Fit varies by style — check the size guide.' : ''));
    }
    sizeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.classList.contains('on') ? 'true' : 'false'); });
    document.querySelectorAll('.pdp-sw').forEach(function (b) { b.setAttribute('aria-pressed', b.classList.contains('on') ? 'true' : 'false'); });
    var cl = document.getElementById('sf-color-label');
    document.querySelectorAll('[data-sf-color-label].on').forEach(function (b) { if (cl) cl.textContent = b.getAttribute('data-sf-val'); });
    if (typeof dutyNote === 'function') { dutyNote(); applyXb(); }
  }

  // Also guard keyboard/programmatic submission; never submit a stale variant.
  var productForm = document.getElementById('sf-product-form');
  if (productForm) productForm.addEventListener('submit', function (e) {
    var v = match();
    if (!v || !v.available) { e.preventDefault(); e.stopImmediatePropagation(); update(); }
  }, true);

  // lightbox (gallery layout)
  var lb = document.getElementById('sf-lightbox');
  var lbImg = document.getElementById('sf-lb-img');
  var lbCount = document.getElementById('sf-lb-count');
  var lbViews = [], lbIndex = 0;
  function lbHiRes(u) { return u ? u.replace(/([?&]width=)\d+/, '$11600') : u; }  // request a bigger CDN render for the zoom
  function lbShow() { if (lbImg) lbImg.src = lbHiRes(lbViews[lbIndex]); if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + lbViews.length; }
  function lbOpen(i) { lbViews = imgMatrix[curColor] || []; if (!lbViews.length) return; lbIndex = Math.max(0, Math.min(i, lbViews.length - 1)); lbShow(); if (lb) { lb.hidden = false; document.body.style.overflow = 'hidden'; } }
  function lbClose() { if (lb) { lb.hidden = true; document.body.style.overflow = ''; } }
  function lbNav(d) { if (!lbViews.length) return; lbIndex = (lbIndex + d + lbViews.length) % lbViews.length; lbShow(); }

  document.addEventListener('click', function (e) {
    var lbBtn = e.target.closest('[data-sf-lb]');
    if (lbBtn) { lbOpen(parseInt(lbBtn.getAttribute('data-sf-lb'), 10) || 0); }
    var lbNavBtn = e.target.closest('[data-sf-lb-nav]');
    if (lbNavBtn) { lbNav(parseInt(lbNavBtn.getAttribute('data-sf-lb-nav'), 10)); }
    if (e.target.closest('[data-sf-lb-close]') || (lb && e.target === lb) || e.target.closest('.sf-lb-stage')) { lbClose(); }
    else if (e.target.closest('#sf-pdp-main')) { lbOpen(curView || 0); }   // click the hero mockup → zoom
    var btn = e.target.closest('[data-sf-opt].pdp-sw, [data-sf-opt].pdp-size');
    if (btn && !btn.disabled) {
      var pos = btn.getAttribute('data-sf-opt');
      document.querySelectorAll('[data-sf-opt="' + pos + '"]').forEach(function (b) { if (b.tagName !== 'SELECT') b.classList.remove('on'); });
      btn.classList.add('on');
      if (btn.classList.contains('pdp-size')) {
        requestedSize = btn.getAttribute('data-sf-val');
        restoredSize = false;
        try { sessionStorage.setItem(sizeStorageKey, requestedSize); } catch (e) {}
      }
      if (btn.classList.contains('pdp-sw')) { curColor = btn.getAttribute('data-sf-val'); refreshSizeAvail(); }
      update();
      if (btn.classList.contains('pdp-sw')) paintColor(btn.getAttribute('data-sf-val'));
    }
    var car = e.target.closest('[data-sf-car]');
    if (car && thumbsEl) {
      thumbsEl.scrollBy({ left: parseInt(car.getAttribute('data-sf-car'), 10) * 220, behavior: 'smooth' });
    }
    var q = e.target.closest('[data-sf-qty]');
    if (q) {
      var qv = document.getElementById('sf-qty-val'), qi = document.getElementById('sf-qty');
      var n = Math.max(1, parseInt(qv.textContent, 10) + parseInt(q.getAttribute('data-sf-qty'), 10));
      qv.textContent = n; qi.value = n;
    }
    var acc = e.target.closest('[data-sf-acc]');
    if (acc) { acc.parentElement.classList.toggle('open'); }
    var thumb = e.target.closest('[data-sf-thumb]');
    if (thumb) {
      var thumbs = Array.prototype.slice.call(thumbsEl ? thumbsEl.querySelectorAll('.pdp-thumb') : []);
      var i = thumbs.indexOf(thumb);
      thumbs.forEach(function (t) { t.classList.remove('on'); });
      thumb.classList.add('on');
      curView = i;
      if (IS_HCAR && heroEl) { scrollHeroTo(i); }
      else if (mainImg) { mainImg.srcset = ''; mainImg.src = thumb.getAttribute('data-sf-thumb'); }
    }
  });

  // hero swipe -> sync the active thumbnail
  if (IS_HCAR && heroEl) {
    var hscrollT;
    heroEl.addEventListener('scroll', function () {
      clearTimeout(hscrollT);
      hscrollT = setTimeout(function () {
        var i = Math.round(heroEl.scrollLeft / heroEl.clientWidth);
        if (i !== curView) { curView = i; setActiveThumb(i); }
      }, 70);
    }, { passive: true });
  }
  // hero-thumbs: cap the vertical rail to the hero's height so it scrolls instead of overhanging
  if (LAYOUT === 'hero-thumbs' && heroEl && thumbsEl) {
    var fitRail = function () { var h = heroEl.getBoundingClientRect().height; if (h > 0) thumbsEl.style.maxHeight = Math.round(h) + 'px'; };
    fitRail();
    window.addEventListener('resize', fitRail);
    window.addEventListener('load', fitRail);
  }
  document.addEventListener('keydown', function (e) {
    if (lb && !lb.hidden) { if (e.key === 'Escape') lbClose(); else if (e.key === 'ArrowLeft') lbNav(-1); else if (e.key === 'ArrowRight') lbNav(1); }
  });
  document.querySelectorAll('[data-sf-select]').forEach(function (s) { s.addEventListener('change', update); });

  // Restore before color initialization can synchronize a default variant to the URL.
  restoreSize();
  refreshSizeAvail();

  // Honor ?color= handed over from a product-card colour pick: select that
  // swatch if it exists, keeping the requested size and validating the combination.
  try {
    var sfWantColor = new URLSearchParams(location.search).get('color');
    if (sfWantColor) {
      document.querySelectorAll('.pdp-sw[data-sf-val]').forEach(function (b) {
        if (b.getAttribute('data-sf-val') === sfWantColor && !b.classList.contains('on')) b.click();
      });
    }
  } catch (e) {}

  // Local shoppers shouldn't LAND on a US-only colour: deploy-time defaults
  // (default_color_random) don't region-filter, so if the pre-selected colour
  // is cross-border, auto-select the first local one. Explicit intents keep
  // the ✈-badged stray instead: ?variant= deep links, ?color= card handover,
  // and shoppers who opted into the US palette (sf-region-pref = 'all').
  try {
    var sfLandQs = new URLSearchParams(location.search);
    if (xbR && !sfPrefAll() && !sfLandQs.get('variant') && !sfLandQs.get('color')) {
      var sfLandOn = document.querySelector('.pdp-sw.on');
      if (sfLandOn && xbColorAll(sfLandOn.getAttribute('data-sf-val'))) {
        var sfLandLocal = Array.prototype.filter.call(
          document.querySelectorAll('.pdp-sw[data-sf-val]'),
          function (b) { return !xbColorAll(b.getAttribute('data-sf-val')); })[0];
        if (sfLandLocal) sfLandLocal.click();
      }
    }
  } catch (e) {}

  update();

  // Colour swatch hover-preview: hovering a circle previews that colour on the
  // main image (keeps the current view angle) without committing; leaving the
  // swatch row reverts to the selected colour. Click still commits (delegated
  // handler above). Mirrors the product-card swatch behaviour.
  (function () {
    var swRow = document.querySelector('.pdp-swatches');
    if (!swRow) return;
    if (!CAN_HOVER) return; // touch: skip hover-preview so the first tap commits
    function committed() {
      var on = document.querySelector('.pdp-sw.on');
      return on ? on.getAttribute('data-sf-val') : curColor;
    }
    document.querySelectorAll('.pdp-sw[data-sf-val]').forEach(function (b) {
      b.addEventListener('mouseenter', function () { paintColor(b.getAttribute('data-sf-val')); });
    });
    swRow.addEventListener('mouseleave', function () { paintColor(committed()); });
  })();

  // ---- share: OS share sheet on touch, styled popover on desktop ----
  // location.href is the share URL — the variant sync above keeps it pointing
  // at the exact colour/size on screen; search/tracking params are stripped.
  (function () {
    var btn = document.getElementById('sf-share-btn');
    var pop = document.getElementById('sf-share-pop');
    if (!btn || !pop) return;
    function shareUrl() {
      var u = new URL(window.location.href);
      ['_pos', '_fid', '_ss', 'preview_theme_id'].forEach(function (p) { u.searchParams.delete(p); });
      return u.href;
    }
    function shareTitle() {
      var h = document.querySelector('.pdp-h');
      return (h ? h.textContent.trim() : document.title) + ' — Shirts Frenzy';
    }
    function close() { pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    var COARSE = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    btn.addEventListener('click', function () {
      // Desktop keeps the popover even where navigator.share exists (Safari,
      // Windows) — it's tidier and carries Pinterest, which the OS sheets don't.
      if (COARSE && navigator.share) {
        navigator.share({ title: shareTitle(), text: shareTitle(), url: shareUrl() }).catch(function () {});
        return;
      }
      if (pop.hidden) {
        var u = encodeURIComponent(shareUrl());
        var t = encodeURIComponent(shareTitle());
        var img = document.querySelector('#sf-pdp-main img');
        var m = encodeURIComponent((img && (img.currentSrc || img.src)) || '');
        pop.querySelector('[data-share-pin]').href = 'https://www.pinterest.com/pin/create/button/?url=' + u + '&media=' + m + '&description=' + t;
        pop.querySelector('[data-share-x]').href = 'https://twitter.com/intent/tweet?url=' + u + '&text=' + t;
        pop.querySelector('[data-share-wa]').href = 'https://wa.me/?text=' + t + '%20' + u;
        pop.querySelector('[data-share-mail]').href = 'mailto:?subject=' + t + '&body=' + u;
        pop.hidden = false; btn.setAttribute('aria-expanded', 'true');
      } else close();
    });
    var copyBtn = pop.querySelector('[data-share-copy]');
    var copyLbl = copyBtn.querySelector('span');
    function copied(ok) {
      copyLbl.textContent = ok ? 'Copied ✓' : 'Copy failed';
      setTimeout(function () { copyLbl.textContent = 'Copy link'; close(); }, 1100);
    }
    function copyLegacy(txt) {
      // insecure context (http dev server) or clipboard API rejected
      try { var ta = document.createElement('textarea'); ta.value = txt; document.body.appendChild(ta); ta.select(); var ok = document.execCommand('copy'); ta.remove(); copied(ok); }
      catch (e) { copied(false); }
    }
    copyBtn.addEventListener('click', function () {
      var txt = shareUrl();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(txt).then(function () { copied(true); }, function () { copyLegacy(txt); });
      } else copyLegacy(txt);
    });
    document.addEventListener('click', function (e) { if (!pop.hidden && !e.target.closest('#sf-share')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
  })();
})();

/* Product reel: muted viewport autoplay, explicit pause and sound controls. */
(function () {
  document.querySelectorAll('[data-pdp-reel]').forEach(function (player) {
    var video = player.querySelector('video');
    var playBtn = player.querySelector('[data-pdp-reel-play]');
    var soundBtn = player.querySelector('[data-pdp-reel-sound]');
    if (!video || !playBtn) return;

    var playlist = Array.from(player.querySelectorAll('[data-pdp-reel-item]')).filter(function (item) {
      return item.content.querySelector('source');
    });
    var reelIndex = 0;
    var counter = player.querySelector('[data-pdp-reel-counter]');
    // Native loop suppresses ended; use it only when there is one reel.
    video.loop = playlist.length < 2;
    function updateCounter() {
      if (counter) counter.textContent = playlist.length > 1 ? 'REEL ' + (reelIndex + 1) + ' / ' + playlist.length : 'NOW PLAYING';
    }
    updateCounter();
    var userPaused = false;
    var playRequest = 0;
    var soundPinned = false;
    var hoverSound = false;
    var mobileSound = false;
    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setPlaying(playing) {
      playBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      playBtn.setAttribute('aria-label', playing ? 'Pause product reel' : 'Play product reel');
      player.classList.toggle('is-playing', playing);
    }

    function loadPoster() {
      if (video.dataset.poster) {
        video.poster = video.dataset.poster;
        delete video.dataset.poster;
      }
    }

    function loadVideo() {
      loadPoster();
      var deferred = video.querySelectorAll('source[data-src]');
      if (!deferred.length) return;
      deferred.forEach(function (source) {
        source.src = source.dataset.src;
        delete source.dataset.src;
      });
      video.load();
    }

    function play(allowMutedFallback) {
      var request = ++playRequest;
      // No video source is attached until playback is requested or in view.
      loadVideo();
      var promise = video.play();
      if (promise && promise.then) {
        promise.then(function () { if (request === playRequest) setPlaying(true); }).catch(function () {
          // pause()/a newer play invalidates pending attempts, including muted retries.
          if (request !== playRequest) return;
          if (allowMutedFallback && !soundPinned && !userPaused && visibleEnough()) {
            mobileSound = false;
            syncSound();
            var fallback = video.play();
            if (fallback && fallback.then) {
              fallback.then(function () { if (request === playRequest) setPlaying(true); }).catch(function () { if (request === playRequest) setPlaying(false); });
            }
          } else {
            setPlaying(false);
          }
        });
      } else {
        setPlaying(true);
      }
    }

    function pause() {
      playRequest += 1;
      video.pause();
      setPlaying(false);
    }

    function syncSound() {
      video.muted = !(soundPinned || hoverSound || mobileSound);
      player.classList.toggle('is-hover-sounding', hoverSound && !soundPinned);
      player.classList.toggle('is-mobile-sounding', mobileSound && !soundPinned);
      if (!soundBtn) return;
      soundBtn.setAttribute('aria-pressed', soundPinned ? 'true' : 'false');
      soundBtn.setAttribute('aria-label', soundPinned ? 'Turn reel sound off' : 'Keep reel sound on');
    }

    playBtn.addEventListener('click', function () {
      if (video.paused) {
        userPaused = false;
        play();
      } else {
        userPaused = true;
        pause();
      }
    });

    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        soundPinned = !soundPinned;
        syncSound();
        if (soundPinned) {
          userPaused = false;
          play();
        }
      });
    }

    player.addEventListener('pointerenter', function (event) {
      if (event.pointerType !== 'mouse') return;
      hoverSound = true;
      syncSound();
    });
    player.addEventListener('pointerleave', function (event) {
      if (event.pointerType !== 'mouse') return;
      hoverSound = false;
      syncSound();
    });

    function visibleEnough() {
      var rect = player.getBoundingClientRect();
      var visible = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      return visible > 0 && visible >= rect.height * 0.35;
    }

    if (isIOS) {
      document.addEventListener('touchend', function () {
        if (!visibleEnough() || userPaused || reduceMotion) return;
        mobileSound = true;
        syncSound();
        play(false);
      }, { passive: true });
    }

    video.addEventListener('ended', function () {
      if (playlist.length < 2 || userPaused) return;
      reelIndex = (reelIndex + 1) % playlist.length;
      var item = playlist[reelIndex];
      video.removeAttribute('src');
      video.querySelectorAll('source').forEach(function (source) { source.remove(); });
      video.appendChild(item.content.cloneNode(true));
      var poster = item.getAttribute('data-poster');
      if (poster) video.setAttribute('poster', poster);
      else video.removeAttribute('poster');
      video.load();
      syncSound();
      updateCounter();
      // Continue an existing viewing session; never override an explicit pause
      // or restart while the player is offscreen.
      if (visibleEnough()) play(true);
    });

    video.addEventListener('play', function () {
      if (!visibleEnough()) { pause(); return; }
      setPlaying(true);
      // A quick Play → scroll can happen between visibility samples. Re-observe
      // on actual playback so even an unchanged offscreen state gets checked.
      if (observer) { observer.unobserve(player); observer.observe(player); }
    });
    video.addEventListener('pause', function () { setPlaying(false); });

    if ('IntersectionObserver' in window) {
      // Only the lightweight poster warms up near the viewport; video bytes wait
      // for playback. The observer runs only until this one poster is needed.
      var posterObserver = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          loadPoster();
          posterObserver.disconnect();
        }
      }, { rootMargin: '200px 0px' });
      posterObserver.observe(player);
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35 && !userPaused && !reduceMotion) {
            if (isIOS) {
              mobileSound = true;
              syncSound();
              play(true);
            } else {
              play(false);
            }
          }
          if (!entry.isIntersecting || entry.intersectionRatio < 0.35) {
            if (isIOS) {
              mobileSound = false;
              syncSound();
            }
            pause();
          }
        });
      }, { threshold: 0.35 });
      observer.observe(player);
    } else {
      loadPoster();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
